import { render, staticRenderFns } from "./filter_settings.vue?vue&type=template&id=2663404a&scoped=true&lang=html&"
import script from "./filter_settings.vue?vue&type=script&lang=js&"
export * from "./filter_settings.vue?vue&type=script&lang=js&"
import style0 from "./filter_settings.vue?vue&type=style&index=0&id=2663404a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2663404a",
  null
  
)

export default component.exports